import { render, staticRenderFns } from "./_publication.vue?vue&type=template&id=81e36824&scoped=true&"
import script from "./_publication.vue?vue&type=script&lang=js&"
export * from "./_publication.vue?vue&type=script&lang=js&"
import style0 from "./_publication.vue?vue&type=style&index=0&id=81e36824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e36824",
  null
  
)

/* custom blocks */
import block0 from "./_publication.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiBreadcrumb: require('/var/www/html/intelli.com.br/components/base/ui/Breadcrumb.vue').default,BaseUiShareOnSocialMedias: require('/var/www/html/intelli.com.br/components/base/ui/ShareOnSocialMedias.vue').default,BaseUiCardPublication: require('/var/www/html/intelli.com.br/components/base/ui/CardPublication.vue').default,BaseUiCardProduct: require('/var/www/html/intelli.com.br/components/base/ui/CardProduct.vue').default,BaseUiSlideIt: require('/var/www/html/intelli.com.br/components/base/ui/SlideIt.vue').default,BaseUiNewsletter: require('/var/www/html/intelli.com.br/components/base/ui/Newsletter.vue').default})
